import context from '../context'
import getComponentKey from '@/utils/getComponentKey'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { allowErrorDialog } from '@/utils/fetch'

const initialState = {
  tree: {},
  fetching: false,
  updating: false,
  componentKey: getComponentKey()
}

export const actionTypes = {
  DocumentationTreeFetching: 'documentation/fetching',
  DocumentationTreeFetched: 'documentation/fetched',
  DocumentationTreeError: 'documentation/errorOccurred',
  DocumentationItemUpdating: 'documentation/updating',
  DocumentationItemUpdated: 'documentation/updated',
  DocumentationItemDeleting: 'documentation/deleting',
  DocumentationItemDeleted: 'documentation/deleted',
  DocumentationTreeChanged: 'documentation/changed',
  DocumentationNewItemCreating: 'documentation/itemCreating',
  DocumentationNewItemCreated: 'documentation/itemCreated'
}

export const ACTIONS = {
  EDIT: 'edit',
  DELETE: 'delete',
  CHANGE: 'change',
  CREATE: 'create'
}

export const actionCreators = {

  loadTree: () => (dispatch) => {
    dispatch({ type: actionTypes.DocumentationTreeFetching })
    context.api.documentationService.get(allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.DocumentationTreeFetched, data: response })
      }).catch(() => dispatch({ type: actionTypes.DocumentationTreeError }))
  },
  create: (input) => (dispatch) => {
    dispatch({ type: actionTypes.DocumentationItemUpdating })
    context.api.documentationService.edit(input, allowErrorDialog)
      .then(() => {
        dispatch({ type: actionTypes.DocumentationItemUpdated })
        dispatch(actionCreators.loadTree())
      }).catch(() => dispatch({ type: actionTypes.DocumentationTreeError }))
  },
  edit: ({ item, localize }) => (dispatch) => {
    dispatch(
      dialogActions.openDialog({
        dialogType: dialogTypes.editDocumentationItem,
        onAction: (input) => {
          dispatch(actionCreators.create(input))
          return true
        },
        item,
        localize,
        downloadAction: context.api.documentationService.download
      }))
  },
  delete: ({ item }) => (dispatch) => {
    dispatch({ type: actionTypes.DocumentationItemDeleting })
    context.api.documentationService.delete(item.treeType, item.id, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.DocumentationItemDeleted })
        if (response === true) { dispatch(actionCreators.loadTree()) }
      }).catch(() => dispatch({ type: actionTypes.DocumentationTreeError }))
  },
  change: ({ treeType, tree }) => (dispatch) => {
    context.api.documentationService.change({ treeType, tree }, allowErrorDialog)
      .then(response => {
        if (response === true) {
          dispatch({ type: actionTypes.DocumentationTreeChanged, data: { treeType, tree } })
        } else {
          dispatch({ type: actionTypes.DocumentationTreeError })
        }
      }).catch(() => dispatch({ type: actionTypes.DocumentationTreeError }))
  }
}
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.DocumentationTreeFetching: return { ...state, fetching: true }
    case actionTypes.DocumentationTreeFetched: return { ...state, fetching: false, tree: action.data, componentKey: getComponentKey() }
    case actionTypes.DocumentationTreeError: return { ...state, fetching: false, updating: false }
    case actionTypes.DocumentationItemUpdating: return { ...state, updating: true }
    case actionTypes.DocumentationItemUpdated: return { ...state, updating: false }
    case actionTypes.DocumentationItemDeleting: return { ...state, updating: true }
    case actionTypes.DocumentationItemDeleted: return { ...state, updating: false }
    case actionTypes.DocumentationTreeChanged:
    {
      const newTree = { ...state.tree }
      newTree[action.data.treeType] = action.data.tree

      return { ...state, tree: newTree, componentKey: getComponentKey() }
    }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/Documentation.js